import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const tones = {
  ink: "bg-[#0E0E10] text-[#F1ECE2] hover:bg-[#FF4D1A]",
  signal: "bg-[#FF4D1A] text-white hover:bg-[#0E0E10]",
  paper: "bg-[#F1ECE2] text-[#0E0E10] hover:bg-[#D4FF3D]",
  ghost: "border border-current hover:bg-[#0E0E10] hover:text-[#F1ECE2]",
};

export const MagneticButton = ({ to, onClick, children, tone = "ink", type = "button", testid, disabled, className = "" }) => {
  const ref = useRef(null);
  const x = useSpring(useMotionValue(0), { stiffness: 220, damping: 15 });
  const y = useSpring(useMotionValue(0), { stiffness: 220, damping: 15 });
  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * 0.25);
    y.set((e.clientY - r.top - r.height / 2) * 0.35);
  };
  const reset = () => { x.set(0); y.set(0); };
  const cls = `group inline-flex items-center gap-3 rounded-full px-6 py-3.5 text-[0.95rem] font-semibold transition-colors duration-300 disabled:opacity-60 ${tones[tone]} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
    </>
  );
  return (
    <motion.span ref={ref} style={{ x, y }} onMouseMove={move} onMouseLeave={reset} className="inline-block">
      {to ? (
        <Link to={to} className={cls} data-testid={testid}>{inner}</Link>
      ) : (
        <button type={type} onClick={onClick} className={cls} data-testid={testid} disabled={disabled}>{inner}</button>
      )}
    </motion.span>
  );
};
